<template>
  <div>
    <el-dialog
      :visible="visible"
      title="更改支付时间"
      width="400px"
      @close="handleClose"
    >
      <el-date-picker
        v-model="copyData.payment_time"
        type="datetime"
        placeholder="选择日期时间"
        :picker-options="effectiveDate"
      >
      </el-date-picker>
      <div class="button-wrap flex">
        <el-button
          class="mwow-button-filled"
          v-debounce="1000"
          @click="handleCancel"
        >
          取消
        </el-button>
        <el-button
          class="mwow-button-filled success"
          v-debounce="1000"
          @click="handleConfirm"
        >
          确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { dateFormat } from "@/utils/timeFormat";
import { eidtPaymentTimeApi } from "@/api/order";

export default {
  props: ["visible", "originData"],
  data() {
    return {
      time: "",
      copyData: {},
      // 未来时间不可选
      effectiveDate: {
        disabledDate(date) {
          return date.getTime() > Date.now();
        },
      },
    };
  },
  watch: {
    visible: {
      handler(n) {
        if (n) {
          this.copyData = this.originData;
          this.copyData.payment_time_bak = this.originData.payment_time;
        }
      },
    },
  },
  methods: {
    handleClose() {
      this.$emit("change");
    },
    handleCancel() {
      this.handleClose();
    },
    handleConfirm() {
      this.$confirm(
        `确认把${this.copyData.order_no}订单的${dateFormat(
          "YYYY-mm-dd HH:MM",
          new Date(this.copyData.payment_time_bak).getTime()
        )}支付单支付时间更改为${dateFormat(
          "YYYY-mm-dd HH:MM",
          new Date(this.copyData.payment_time).getTime()
        )}？`,
        "更改支付时间",
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
        }
      ).then(() => {
        eidtPaymentTimeApi({
          order_payment_id: Number(this.originData.order_payment_id),
          payment_time: new Date(this.copyData.payment_time).getTime() / 1000,
        }).then((res) => {
          if (res.error_code === 0) {
            this.$message({
              message: "更改成功",
              type: "success",
            });
            this.$emit("change", true);
          }
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.el-date-editor {
  width: 100% !important;
}
.button-wrap {
  margin: 10px 0 0 0;
}

.flex {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>
